var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.445 4.635a2.222 2.222 0 013.11 0l.426.417c.41.401.958.628 1.531.634l.597.006c1.209.013 2.186.99 2.199 2.2l.006.595c.006.574.233 1.123.634 1.532l.417.426a2.222 2.222 0 010 3.11l-.417.426c-.401.41-.628.958-.634 1.531l-.006.597a2.222 2.222 0 01-2.2 2.199l-.596.006a2.222 2.222 0 00-1.531.634l-.426.417a2.222 2.222 0 01-3.11 0l-.426-.417a2.222 2.222 0 00-1.532-.634l-.596-.006a2.222 2.222 0 01-2.199-2.2l-.006-.596a2.222 2.222 0 00-.634-1.531l-.417-.426a2.222 2.222 0 010-3.11l.417-.426c.401-.41.628-.958.634-1.532l.006-.596a2.222 2.222 0 012.2-2.199l.595-.006a2.222 2.222 0 001.532-.634l.426-.417z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15a1 1 0 100-2 1 1 0 000 2zM10 11a1 1 0 100-2 1 1 0 000 2z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15l6-6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgPromotions;